package com.mgacreative.hotel.shared.ui.designsystem.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotel.shared.ui.designsystem.i18n.AppLanguage
import com.mgacreative.hotel.shared.ui.designsystem.i18n.AppLocalizationManager

@Composable
fun LanguageSelectorRow(
    modifier: Modifier = Modifier,
    isDarkTheme: Boolean = false
) {
    val currentLanguage by AppLocalizationManager.currentLanguage.collectAsState()

    Row(
        modifier = modifier
            .clip(RoundedCornerShape(20.dp))
            .background(if (isDarkTheme) Color.White.copy(alpha = 0.15f) else Color(0xFFF1F5F9))
            .border(
                1.dp,
                if (isDarkTheme) Color.White.copy(alpha = 0.2f) else Color(0xFFE2E8F0),
                RoundedCornerShape(20.dp)
            )
            .padding(3.dp),
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        listOf(AppLanguage.TR, AppLanguage.EN).forEach { lang ->
            val isSelected = currentLanguage == lang
            Box(
                modifier = Modifier
                    .clip(RoundedCornerShape(16.dp))
                    .background(
                        when {
                            isSelected && isDarkTheme -> Color.White
                            isSelected && !isDarkTheme -> Color(0xFF2563EB)
                            else -> Color.Transparent
                        }
                    )
                    .clickable { AppLocalizationManager.setLanguage(lang) }
                    .padding(horizontal = 12.dp, vertical = 6.dp),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    text = "${lang.flag} ${lang.displayName}",
                    fontSize = 12.sp,
                    fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Medium,
                    color = when {
                        isSelected && isDarkTheme -> Color(0xFF0F172A)
                        isSelected && !isDarkTheme -> Color.White
                        !isSelected && isDarkTheme -> Color.White
                        else -> Color(0xFF475569)
                    }
                )
            }
        }
    }
}
